export const ERRORS = {
    GONE: 'GONE',
    UNAUTHORIZED: 'UNAUTHORIZED',
    DEFAULT: 'DEFAULT',
};
